<template>
  <div class="c-entrepreneur-title-text">
    <div class="c-entrepreneur-title-text__inner">
      <!-- ici maintenant -->
      <entrepreneur-title-text-hero :data="data.primary" :is-icon-visible="isIconVisible(data.primary.icon)" />
      <!-- copy -->
      <entrepreneur-title-text-copy :data="data.primary" />
    </div>
  </div>
</template>

<script>
import EntrepreneurTitleTextCopy from "components/EntrepreneurTitleText/EntrepreneurTitleTextCopy";
import EntrepreneurTitleTextHero from "src/templates/components/EntrepreneurTitleText/EntrepreneurTitleTextHero";
export default {
  components: {
    EntrepreneurTitleTextCopy,
    EntrepreneurTitleTextHero
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  methods: {
    isIconVisible(val) {
      return val === "Yes";
    }
  }
};
</script>

<style lang="scss">
.c-entrepreneur-title-text {
  @include sectionColouredPadding;
  display: flex;
  flex-direction: row;
  height: 100%;

  @media #{$breakpoint-horizontal} {
    margin-bottom: 3em; //I am not sure why there is a margin at the top, so I will add one at the bottom too */
  }
  @media #{$breakpoint-vertical} {
    justify-content: center;
  }
  &__inner {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    /* padding: 0px var(--grid-gutter); */
    flex-direction: column;
    @media #{$breakpoint-horizontal} {
      flex-direction: row;
    }
    @media #{$breakpoint-vertical} {
      width: fit-content;
      max-width: 100%;

      // width 0 lets the heading set the column; min-width 100% wraps the copy inside it
      .c-entrepreneur-title-text-copy {
        width: 0;
        min-width: 100%;
      }
    }
  }
}
</style>
